export default __webpack_public_path__ + "static/media/4700@2x.273b6f5d.webp";